import moment from "moment";
export default {
  methods: {
    toLocalDate(date) {
      return moment.parseZone(date).local();
    }
  }
};
